import React from 'react';
import { Outlet } from 'react-router-dom';
import FullWidthCenteredLayout from "../../components/FullWidthCenteredLayout/FullWidthCenteredLayout";
const AppointmentsPageLayout = () => {
    return (
        <div data-testid="page-layout">
            <FullWidthCenteredLayout >
                <Outlet />
            </FullWidthCenteredLayout>
        </div>

    )
}
export default AppointmentsPageLayout